import { combineReducers } from '@reduxjs/toolkit'

import {
  BILLING_CHARGES_LIST_REDUCER_NAME,
  GET_BILLING_CHARGES_REDUCER_NAME,
} from './consts'
import { billingChargesListReducer, getBillingChargesReducer } from './slice'

export default combineReducers({
  [GET_BILLING_CHARGES_REDUCER_NAME]: getBillingChargesReducer,
  [BILLING_CHARGES_LIST_REDUCER_NAME]: billingChargesListReducer,
})
